module.exports = __webpack_public_path__ + "img/34f9f6f.jpg";